import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'cancer_screenings'

const answers: AnswerType[] = [
  {
    emoji: '🚫‍',
    title: 'pages.onboarding.cancerScreenings.options.never',
    value: 'never',
  },
  {
    emoji: '❗️',
    title: 'pages.onboarding.cancerScreenings.options.rarely',
    value: 'rarely',
  },
  {
    emoji: '📅',
    title: 'pages.onboarding.cancerScreenings.options.occasionally',
    value: 'occasionally',
  },
  {
    emoji: '🛡️',
    title: 'pages.onboarding.cancerScreenings.options.regularly',
    value: 'regularly',
  },
]

export default function CancerScreeningsPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Are your cancer screenings up to date?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.cancerScreenings.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
